export enum StatusQueryState {
  Active = 'active',
  Disabled = 'disabled',
  Deleted = 'deleted',
}
